export default {
  role_account: "Account",
  role_account_dataexportxml: "XML",
  role_Users: "Users",
  role_account_subusers: "View",
  role_account_subusers_edit: "Edit",
  role_Contacts: "Contacts",
  role_account_contacts: "View",
  role_account_contacts_edit: "Edit",
  role_account_loginhistory: "Login history",
  role_Roles: "Roles",
  role_account_role: "View",
  role_account_role_edit: "Edit",
  role_Tags: "Tags",
  role_account_tag: "View",
  role_account_tag_edit: "Edit",
  role_API: "API",
  role_intgrtns: "Integrations",
  role_account_apikeys: "View",
  role_account_apikeys_edit: "Edit",
  role_alrt: "Alerts",
  role_alrt_alertsadd: "Add",
  role_alrt_alertsedit: "Edit",
  role_alrt_alertsoffhour: "Off-hours",
  role_alrt_mediaalerts: "Manage media alerts",
  role_account_ect2_read: "EVIR Settings",

  role_apolloeld: "Apollo ELD",
  role_behavior: "Behavior",
  role_Behavior: "Behavior (Points)",
  role_behavior_behmng: "View",
  role_behavior_behmng_edit: "Edit",

  role_cariq: "Car IQ Pay",
  role_db: "Dashboard",
  role_defDrvr: "Default Driver",
  role_wgrs: "Device Warnings",
  role_wgrs_wgdl: "Delete device warnings",
  role_wgrs_wgrd: "Resolve device warnings",

  role_dformview: "Display Forms",
  role_drvapp: "Driver App",
  role_drvapp_dappcht: "Chat",
  role_drvapp_dappfrm: "Forms",
  role_drvapp_dapptck: "Time clock",
  role_DriverStatus: "Driver Status",
  role_drvapp_dappdst: "View",
  role_drvapp_dappdst_edit: "Edit",
  role_drvapp_dapprta: "Route tracker",
  role_drvapp_dapprtc: "Time card",
  role_drvapp_dapprfr: "Driver forms",
  role_drvapp_dapprcht: "Chat history",
  role_drvapp_dappfss: "Form stop summary V2",
  role_drvapp_dappcombr: "Combined V2",
  role_drvapp_dappdrst: "Driver status V2",
  role_drvapp_dappstsr: "Stop summary V2",
  role_drvapp_bdrvcht: "Driver-to-driver chat",

  role_driverPer: "Driver Performance",
  role_eld: "ELDFleet",
  role_etalink: "ETA Link",

  role_evir: "EVIR",
  role_evir_adminusers: "Manage users",
  role_evir_showopen: "View inspection reports",
  role_evir_addrepair: "Add repair record",
  role_evir_assignmechanic: "Assign user to repair",
  role_evir_ect2customeradmin: "Assign customer admin",
  role_evir_evir2draftweb: "Test draft configurations in EVIR 2.0 Web",
  role_evir_evir2draftmobile: "Test draft configurations in EVIR 2.0 Mobile",
  role_evir_evir2inspector: "Perform inspections",
  role_evir_evir2inspectorwithrentals: "Perform inspections with rentals",

  role_fcscoll: "Faces Collections",
  role_feedback: "Feedback",
  role_fldsync: "Field Sync",
  role_fsm: "FSM",
  role_fsm_twowaycomm: "Messages",
  role_fsm_routemanager: "Routes",
  role_fsm_fsmsettings: "Settings",
  role_fsm_fsm_fg: "Forms",
  role_fsm_drvtodrvcomm: "Driver-to-driver communication",

  role_pFuelLev: "Fuel Level",
  role_help: "Help Center",
  role_incdnt: "Incidents",
  role_vm: "Legacy Maintenance",
  "role_mntnnc-beta": "Maintenance",
  "role_mntnnc-beta_carb": "Emission check",

  role_manage: "Manage",
  role_Equipment: "Equipment",
  role_manage_ve: "View",
  role_manage_ve_edit: "Edit",
  role_manage_ckeyfob: "DriverID tags",
  role_manage_fuel: "Fuel cards",
  role_manage_ctemp: "Temperature (Calamp)",
  role_Crews: "Crews",
  role_manage_cwm: "View",
  role_manage_cwm_edit: "Edit",
  role_UnitSettings: "Unit settings",
  role_manage_unitsettingsedit: "View",
  role_manage_unitsettingsedit_edit: "Edit",
  role_VehicleStatus: "Vehicle Status",
  role_manage_vehstatuslabels: "View",
  role_manage_vehstatuslabels_edit: "Edit",
  role_Locations: "Locations",
  role_manage_unitlocations: "View",
  role_manage_unitlocations_edit: "Edit",
  role_manage_mediamanagecam: "Camera management",
  role_Inputs: "Inputs",
  role_manage_inplbl: "View",
  role_manage_inplbl_edit: "Edit",
  role_Driver: "Drivers",
  role_manage_driver: "View",
  role_manage_driver_edit: "Edit",
  role_manage_delDriver: "Delete",
  role_Asset: "Assets",
  role_manage_ast: "View",
  role_manage_ast_edit: "Edit",
  role_Fuelcards: "Fuel card",
  role_manage_fuel: "View",
  role_manage_fuel_edit: "Edit",
  role_AssetSubtypes: "Asset subtypes",
  role_manage_aststp: "View",
  role_manage_aststp_edit: "Edit",
  role_Temperature: "Temperature",
  role_manage_ctemp: "View",
  role_manage_ctemp_edit: "Edit",
  role_KeyFobs: "Key fobs",
  role_manage_ckeyfob: "View",
  role_manage_ckeyfob_edit: "Edit",
  role_DriverStatus: "Driver status",
  role_manage_driverstatus: "View",
  role_manage_driverstatus_edit: "Edit",

  role_dformdesign: "Manage Forms",
  role_dformdesign_sigcap: "Signature capture",
  role_dformdesign_photoup: "Photo upload",

  role_realtimemaps: "Maps",
  role_realtimemaps_gf: "Geofences",
  role_realtimemaps_lm: "Landmarks",
  role_realtimemaps_mapsettings: "Map settings",
  role_realtimemaps_maptrails: "Vehicle trails",
  role_realtimemaps_sendsms: "Send messages",
  role_realtimemaps_maprouadd: "Routes",
  role_realtimemaps_direct: "Vehicle directions",
  role_realtimemaps_mapnearest: "Find nearest",
  role_realtimemaps_speedov: "Speed override",
  role_realtimemaps_vctl: "Vicinity tool",
  role_realtimemaps_animationmap: "Animation maps",

  role_marketplace: "Marketplace",
  role_media: "Media",
  role_media_medialivevideo: "Fetch live video",
  role_media_mediaimagesvideo: "Fetch images and video",
  role_media_mediadownload: "Media download",
  role_media_mediashare: "Media share",
  role_media_mediaview: "View",
  role_media_mediaedit: "Edit",
  role_media_mediareview: "Perform review",
  role_media_mediareviewchecklist: "Manage review checklist",
  role_media_mediapanicaler: "Receive panic button alerts",

  role_mobile: "Mobile",
  role_mobile_appcloudmobile: "Cloud Mobile",

  role_monarch: "Monarch",
  role_monarch_mdriveri: "Driver I cameras",
  role_monarch_meld: "ELD Premium",
  role_monarch_mclassic: "Classic platform",
  role_monarch_mditat: "DIAT TMS",
  role_monarch_intangles: "Monarch intangles",

  role_promiles: "Promiles",
  role_nr: "Reports",
  role_nr_sum: "Summary",
  role_nr_der: "Detailed",
  role_nr_sur: "Simple",
  role_nr_spr: "Speed",
  role_nr_mir: "Mileage",
  role_nr_ssi: "Start Stop Idle",
  role_nr_idl: "Idle",
  role_nr_stp: "Stop",
  role_nr_ign: "Ignition",
  role_nr_tsr: "Time part",
  role_nr_inp: "Input",
  role_nr_evt: "Event",
  role_nr_sst: "Moving",
  role_nr_sr: "Scheduled reports",
  role_nr_gfr: "Geofence",
  role_nr_stm: "Miles per state",
  role_nr_lmi: "Landmark",
  role_nr_lalo: "Latitude/Longitude",
  role_nr_lmb: "Landmark based",
  role_nr_dtsr: "Driver timesheet",
  role_nr_temp: "Temperature",
  role_nr_ping: "Ping",
  role_nr_loc: "Location",
  role_nr_ui: "Unit information",
  role_nr_vmi: "Vehicle maintenance items (legacy)",
  role_nr_vsi: "Vehicle service items (legacy)",
  role_nr_ms: "Mileage summary",
  role_nr_fcr: "Fuel purchases",
  role_nr_mpg: "Miles per gallon",
  role_nr_sfy: "Driver safety",
  role_nr_fch: "Chat history",
  role_nr_fsh: "Stop history",
  role_nr_ftc: "Time card",
  role_nr_fdf: "FSM driver forms",
  role_nr_fc: "Combined",
  role_nr_twm: "Two-way messaging",
  role_nr_rse: "Route stop events",
  role_nr_mdf: "MDT driver forms",
  role_nr_mds: "MDT driver status",
  role_nr_did: "Diagnostic indicators",
  role_nr_dpa: "Diagnostic parameters",
  role_nr_teh: "Engine hours",
  role_nr_jd: "J-1708/1939 diagnostics",
  role_nr_js: "J-1708/1939 summary",
  role_nr_gfb: "Geofence based",
  role_nr_jdtc: "J-1708/1939 DTC",
  role_nr_log: "Alert log",
  role_nr_lmc: "Landmark crew",
  role_nr_nrr: "Not reporting",
  role_nr_ssr: "Stop summary",
  role_nr_or: "Odometer",
  role_nr_fds: "FSM driver status",
  role_nr_avs: "Advanced summary",
  role_nr_mrs: "Mileage reimbursement summary",
  role_nr_ffss: "Form stop summary",
  role_nr_ls: "Landmark summary",
  role_nr_leh: "Engine hours at landmarks",
  role_nr_socutil: "Smart One C utilization",
  role_nr_dvcsuminfo: "Device summary/info",
  role_nr_utlz: "Utilization",
  role_nr_vehiclemaintenanceitems: "Vehicle maintenance items",
  role_nr_vehicleserviceitems: "Vehicle service items",
  role_nr_acr: "Activity with hour meter report",
  role_nr_smisum: "State miles summary report",
  role_nr_smicross: "State miles crossing report",
  role_nr_tcr: "Time card V2",
  role_nr_chv2r: "Chat history report V2",
  role_nr_drfv2r: "Driver forms report V2",
  role_nr_hoofus: "Hours of use report",
  role_nr_behrep: "Behavior report",
  role_nr_drmisumm: "Driver mileage summary report",
  role_nr_drcoach: "Driver coaching report",
  role_nr_spcoach: "Speed coaching report",
  role_nr_dlytpr: "Trip report",
  role_nr_fllvlrp: "Fuel level report",

  role_routes: "Routes",
  role_vstat: "Status",
  role_vstat_locate: "Locate",
  role_vstat_uout: "Outputs",
  role_vstat_starter_ed: "Starter control",
  role_vstat_unitsettings: "Edit unit settings",
  role_vstat_unitalertsheavy: "Heavy duty alerts",
  role_vstat_unitalertsobd2: "Light duty alerts",

  role_training: "Training",
  role_trbusr: "User Troubleshooting",

  role_vidfleetvideo: "Video",
  role_vidfleetvideo_livestreaming: "Live",
  role_vidfleetvideo_vidrw: "Video review",
  role_vidfleetvideo_vfsetup: "VidFleet setup",
  role_vidfleetvideo_dtlvdo: "Delete video",
  role_vidfleetvideo_vassdrv: "Assign driver",
  role_vidfleetvideo_vfdrid: "VidFleet setup - Driver ID",
  role_vidfleetvideo_privatecliprequest: "Private clip request",
  role_vidfleetvideo_snapshoot: "Snapshoot",
  role_vidfleetvideo_videorequest: "Video request",
  role_vidfleetvideo_livevideo: "Live video",
  role_oemdata: "OEM Data",
  role_oemdata_remotecommands: "Remote commands",

  role_wbhook: "Webhook",
  role_workorders: "Work orders",
  role_WorkOrdersCatalogs: "Work Orders Catalogs",
  role_workorders_womanage: "View",
  role_workorders_womanage_edit: "Edit",
  role_zpass: "Z Pass",
  role_zpass_adminzpass: "Z Pass admin",
  role_zpass_viewzpass: "View Z Pass",

  role_zlogs: "Zonar ELD",
  role_zlogs_hosdispatch: "ZLogs - Hours of Service - dispatch",

  role_role: "Role",
  role_permissions: "Permissions",
  role_alerts: "Alerts",
  role_reports: "Reports",
  role_edit: "Edit Role",
  role_create: "Create a New Role",
  role_label: "Role Label",
  role_minMessageUserType: "The role must contain minimun chars:",
  role_maxMessageUserType: "The role must contain maximum chars:",
  role_globalAccess: "Global Access",
  role_localAccess: "Local Access",
  role_createMessage: "Role Created",
  role_editMessage: "Role Updated",
  role_deleteMessage: "Role Deleted",
  role_messageDelete: "Are you sure you want to delete the roles?",
  role_delete: "Delete Role",
  role_custom: "Role Custom",
  role_supervisor: "Supervisor",
  role_thisUsetsupervisor: "This user is a Supervisor",
  "role_Data Exports": "Data exports",
  role_General: "General",
  role_Alerts: "Alerts",
  role_Management: "Management",
  role_Reports: "Reports",
  role_Settings: "Settings",
  role_Maintenance: "Maintenance",
  role_Landmark: "Landmark",
  "role_General Media": "General media",
  "role_Media Review": "Media review",
  role_Basic: "Basic",
  role_Event: "Event",
  role_Main: "Main",
  role_Location: "Location",
  role_Other: "Other",
  "role_Legacy Maintenance": "Legacy maintenance",
  "role_Fuel Card": "Fuel card",
  role_Diagnostic: "Diagnostic",
  "role_Unit Specific Alerts": "Unit specific alerts",
  role_coachsso: "Coaching",
  role_coachsso_coachsso_admin: "Admin",
  role_coachsso_coachsso_manager: "Fleet Manager",
  role_coachsso_coachsso_coach: "Safety Coach"
};
